
import { defineComponent } from 'vue';

const DELAY = 100; // in milliseconds

export default defineComponent({
  name: 'AlertComponent',

  props: {
    type: { type: String, required: true },
    timed: { type: Boolean, default: false },
    dismissible: { type: Boolean, default: false },
    totalShowTime: { type: Number, default: 3000 },
  },

  data: () => ({
    showTime: 0,
    interval: null as ReturnType<typeof setInterval> | null,
  }),

  computed: {
    className() {
      return `${this.type}-alert`;
    },

    icon(): string {
      if (this.type === 'warning') {
        return 'mdi-alert-outline';
      }
      if (this.type === 'error' || this.type === 'input-error') {
        return 'mdi-alert-circle-outline';
      }

      return 'mdi-checkbox-marked-circle';
    },

    progressBarPercentage(): number {
      return (100 / this.totalShowTime) * this.showTime;
    },

    alertColorVariable(): string {
      if (this.type === 'input-error') {
        return 'var(--error-color)';
      }
      return `var(--${this.type}-color)`;
    },
  },

  methods: {
    close() {
      this.clearInterval();
      this.$emit('dismissed');
    },

    clearInterval() {
      if (this.interval) clearInterval(this.interval);
    },
  },

  mounted() {
    if (!this.timed) return;

    this.showTime = this.totalShowTime;

    this.interval = setInterval(() => {
      if (this.showTime < 0) {
        this.close();
      } else {
        this.showTime -= DELAY;
      }
    }, DELAY);
  },

  destroyed() {
    this.clearInterval();
  },
});
